import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants";

export const triggerRouteChangeSpaMountEvent = (mountedApps: Array<string>, to: string): void => {
	OcmMessenger.publish(messengerPublicationTypes.ROUTE_CHANGE_MOUNTED_APPS, { mountedApps, to });
};

export const triggerRouteChangeSpaEvent = (to: string): void => {
	OcmMessenger.publish(messengerPublicationTypes.ROUTE_CHANGE, to);
};

export const triggerSaveProductListState = (currentRoute: string): void => {
	OcmMessenger.publish(messengerPublicationTypes.SAVE_PRODUCTLIST_STATE, currentRoute);
};

export const triggerWishlistUnmountedEvent = (): void => {
	OcmMessenger.publish(messengerPublicationTypes.UNMOUNTED_WISHLIST);
};

export const triggerCartUnmountedEvent = (): void => {
	OcmMessenger.publish(messengerPublicationTypes.UNMOUNTED_CART);
};

export const triggerRecoClickedEvent = (data: { provider: string }): void => {
	OcmMessenger.publish(messengerPublicationTypes.RECO_CLICKED, data);
};
